import { createStyles, Theme } from '@material-ui/core/styles';
import { AvatarProps } from './types';

const styles = (theme: Theme) =>
  createStyles({
    root: (props: Pick<AvatarProps, 'height' | 'width'>) => ({
      display: 'flex',
      '& > *': {
        margin: theme.spacing(1)
      },
      ...props
    }),
    small: {
      width: theme.spacing(3),
      height: theme.spacing(3)
    },
    medium: {
      width: theme.spacing(5),
      height: theme.spacing(5)
    },
    large: {
      width: theme.spacing(7),
      height: theme.spacing(7)
    }
  });

export default styles;
